<template>
    <div class="card">
        <card>
            <div class="d-flex justify-content-between border-bottom pb-1 mb-5">
                <h4 slot="header" class="card-title">{{this.$route.params.id === undefined ? 'Ajout' : 'Modification'}} d'un contact</h4>
                <n-button slot="header" type="primary" class="btn btn-sm btn-primary mt-4 h-25" @click.native="backToList()">
                    Retour
                </n-button>
            </div>
            <div class="d-flex justify-content-center">
                <form>
                    <div class="mb-3">
                        <label for="name" class="input-label">
                            Nom & Prénom
                        </label>
                        <fg-input id="name" v-model="contact.name"></fg-input>
                    </div>
                    <div class="mb-3">
                        <label for="email" class="input-label" >
                            Email
                        </label>
                        <fg-input id="email" v-model="contact.email"></fg-input>
                    </div>
                    <div class="mb-3">
                        <label for="phone" class="input-label">
                            N° de téléphone
                        </label>
                        <fg-input id="phone" v-model="contact.phone"></fg-input>
                    </div>
                    <div class="mb-3">
                        <label for="supplier" class="input-label">
                            Fournisseur
                        </label>
                        <fg-input class="select" name="supplier_id" v-validate="'required'" v-model="contact.supplier_id">
                            <el-select id="supplier"
                                :class="errors.first('supplier_id') ? 'has-error' : ''"
                                placeholder="Choisir un fournisseur" v-model="contact.supplier_id"
                                filterable>
                                <el-option v-for="supplier in supplier.options" :key="supplier.id"
                                    :label="supplier.num + ' - ' + supplier.name"
                                    :value="supplier.id">
                                </el-option>
                            </el-select>
                            <slot name="helpBlock">
                                <div class="text-danger invalid-feedback" style="display: block"
                                    :class="'mt-2'" v-if="errors.first('supplier_id')">
                                    {{ errors.first('supplier_id') }}
                                </div>
                            </slot>
                        </fg-input> 
                    </div>
                    <div class="text-center"> 
                        <n-button class="btn btn-sm btn-primary radius" @click.native="save()">
                            Enregistrer
                        </n-button>
                    </div>
                </form>
            </div>
        </card>
    </div>
</template>
<script>
import Form from 'vform'
import { Select, Option } from 'element-ui'
    export default {
        name:'ContactForm',
        components: {
            [Select.name]: Select,
            [Option.name]: Option,
        },
        data() {
            return {
                contact: new Form({
                    id: '',
                    email: '',
                    name: '',
                    phone: '',
                    supplier_id: ''
                }),

                supplier: {
                    options: []
                }
            }
        },
        mounted() {

            this.axios.get(process.env.VUE_APP_API_BASE_URL + `fnc/supplier/list`).then((response) => {
                this.supplier.options = response.data
                //récupération du détails d'un contact pour la modification
                if(this.$route.params.id !== undefined){
                    this.axios.get(process.env.VUE_APP_API_BASE_URL + `fnc/contact/` + this.$route.params.id).then((response) => {

                        this.contact.id = this.$route.params.id
                        this.contact.email = response.data.email
                        this.contact.name = response.data.name
                        this.contact.phone = response.data.phone
                        this.contact.supplier_id = response.data.supplier_id
                    })
                }
            }) 

            

            
        },
        methods: {
            backToList(){
                this.$router.push({ name: 'fnc admin', params: { selected: "contact"} })            
            },

            save(){
                
                this.contact.phone = this.contact.phone.replace(/ /g, "")
                this.contact.phone = this.contact.phone.replace(/\./g, "")

                // fonction permettant la modification d'un contact
                if(this.$route.params.id !== undefined){
                this.contact.post(process.env.VUE_APP_API_BASE_URL + `contact/update/` + this.$route.params.id).then((response => {
                    this.$notify({ message: 'Le contact à bien été mmodifié', type: "success", verticalAlign: "bottom" })
                    this.backToList()
                }))
                // fonction permettant l'ajout d'un contact
                } else {
                    this.contact.post(process.env.VUE_APP_API_BASE_URL + `contact/add`).then((response => {
                        this.$notify({ message: 'Le contact à bien été enregistré', type: "success", verticalAlign: "bottom" })
                        this.backToList()
                    }))
                }
            }
        },
        
    }
</script>